import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { appReducer } from './reducers/appReducers';
import {
  groupCreateReducer,
  groupDeleteReducer,
  groupDetailsReducer,
  groupListReducer,
  groupUpdateReducer,
} from './reducers/groupReducers';
import {
  productCreateReducer,
  productDeleteReducer,
  productDetailsReducer,
  productListReducer,
  productUpdateReducer,
} from './reducers/productReducers';
import {
  getRequestCountReducer,
  requestApproveReducer,
  requestCommentsReducer,
  requestCreateReducer,
  requestDeleteReducer,
  requestDetailsReducer,
  requestListMyReducerAsChampion,
  requestListMyReducerAsInitiator,
  requestListMyReducerAsTaskholder,
  requestListMyReducerAsUser,
  requestListReducer,
  requestSendMailReducer,
  requestUpdateReducer,
  requestWithdrawReducer,
} from './reducers/requestReducers';
import {
  userDeleteReducer,
  userDetailsReducer,
  userListForEcrReducer,
  userListReducer,
  userLoginReducer,
  userRegisterReducer,
  userUpdateProfileReducer,
  userUpdateReducer,
} from './reducers/userReducers';

const reducer = combineReducers({
  requestList: requestListReducer,
  getRequestCount: getRequestCountReducer,
  requestListMyInitiator: requestListMyReducerAsInitiator,
  requestListMyChampion: requestListMyReducerAsChampion,
  requestListMyTaskholder: requestListMyReducerAsTaskholder,
  requestListMyUser: requestListMyReducerAsUser,
  requestDetails: requestDetailsReducer,
  requestDelete: requestDeleteReducer,
  requestCreate: requestCreateReducer,
  requestUpdate: requestUpdateReducer,
  requestApprove: requestApproveReducer,
  requestWithdraw: requestWithdrawReducer,
  requestComment: requestCommentsReducer,
  userLogin: userLoginReducer,
  userRegister: userRegisterReducer,
  userDetails: userDetailsReducer,
  userUpdateProfile: userUpdateProfileReducer,
  userList: userListReducer,
  userDelete: userDeleteReducer,
  userUpdate: userUpdateReducer,
  userListForEcr: userListForEcrReducer,
  productList: productListReducer,
  productDelete: productDeleteReducer,
  productCreate: productCreateReducer,
  productUpdate: productUpdateReducer,
  productDetails: productDetailsReducer,
  groupList: groupListReducer,
  groupDelete: groupDeleteReducer,
  groupCreate: groupCreateReducer,
  groupUpdate: groupUpdateReducer,
  groupDetails: groupDetailsReducer,
  requestMail: requestSendMailReducer,
  app: appReducer,
});

const userInfoFromStorage = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo'))
  : null;

const initialState = {
  // ...appState,
  userLogin: { userInfo: userInfoFromStorage },
};

const middleware = [thunk];

export const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

window.store = store;

export const { dispatch, getState } = store;
